const data = [
    { name: "PRINCIPAIS DOCUMENTOS", route: "/principais-documentos" },
    { name: "RELATÓRIOS MENSAIS", route: "/relatorios-mensais" },
];

export default [...data];
